import React from 'react';
import Icon from '../AppIcon';

/**
 * Aperçu type fiche e-commerce pour un produit CRM.
 */
export default function ProductSheetPreview({
  name = '',
  description = '',
  price,
  videoLink = '',
  imageUrl = '',
  className = '',
}) {
  const hasName = String(name || '').trim().length > 0;
  const priceNum =
    typeof price === 'number' && !Number.isNaN(price)
      ? price
      : price !== '' && price != null
        ? Number(price)
        : null;
  const showPrice = priceNum != null && !Number.isNaN(priceNum) && priceNum > 0;
  const hasVideo = String(videoLink || '').trim().length > 0;
  const descHtml = String(description || '').trim();

  return (
    <div
      className={`overflow-hidden rounded-xl border border-border bg-card shadow-elevation-1 ${className}`}
    >
      <div className="aspect-[4/3] bg-muted/50 relative flex items-center justify-center overflow-hidden">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt=""
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="flex flex-col items-center gap-2 text-muted-foreground px-4 text-center">
            <Icon name="Image" size={36} className="opacity-50" />
            <span className="text-xs">Photo du produit</span>
          </div>
        )}
      </div>
      <div className="p-4 space-y-3">
        <div className="flex items-start justify-between gap-2">
          <h3 className="text-lg font-semibold text-foreground leading-snug">
            {hasName ? name : 'Nom du produit'}
          </h3>
          {showPrice ? (
            <span className="shrink-0 rounded-full bg-primary/10 px-2.5 py-1 text-sm font-bold text-primary tabular-nums">
              {priceNum.toFixed(2)} €
            </span>
          ) : null}
        </div>
        {descHtml ? (
          <div
            className="text-sm text-muted-foreground prose prose-sm max-w-none leading-relaxed"
            dangerouslySetInnerHTML={{ __html: descHtml }}
          />
        ) : (
          <p className="text-sm text-muted-foreground italic">
            La description apparaîtra ici.
          </p>
        )}
        {hasVideo ? (
          <div className="inline-flex items-center gap-1.5 rounded-md border border-border bg-muted/40 px-2.5 py-1.5 text-xs font-medium text-foreground">
            <Icon name="Video" size={14} className="text-primary" />
            Vidéo de présentation
          </div>
        ) : null}
      </div>
    </div>
  );
}
